import React from 'react';

import { useHistory } from 'react-router-dom';

import TableHeader from '../../../../../components/Table/TableHeader';
import TablePagination from '../../../../../components/Table/TablePagination';

const tabelaColunas = ['Data / Hora', 'Usuário', 'Arquivo', 'Total', 'OK', 'Aviso', 'Duplicado', 'Erro', 'Status']

const PerfilSellerListOportunidadeLog = ({
    response,
    mudarPagina,
    exportarLogOportunidade
}) => {
    const history = useHistory();

    const changePage = (page) => {
        mudarPagina(page);
    }

    return (
        <div>
            <div className="row">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table">
                            <TableHeader columns={tabelaColunas} />

                            <tbody>
                                {
                                    (!response?.lista || response?.lista.length === 0) &&
                                    <tr><td colSpan="7"> Sem Registros </td></tr>
                                }
                                {
                                    response?.lista && response?.lista?.map((data, i) => (
                                        <tr key={i}>
                                            <td> {data.dataHoraImportacao} </td>
                                            <td> {data.usuario} </td>
                                            <td> {data.nomeArquivo} </td>
                                            <td onClick={() => exportarLogOportunidade(1, data.id)}> {data.totalRegistroArquivo} </td>
                                            <td onClick={() => exportarLogOportunidade(0, data.id)}> {data.totalRegistroSucesso} </td>
                                            <td onClick={() => exportarLogOportunidade(2, data.id)}> {data.totalRegistroAviso} </td>
                                            <td onClick={() => exportarLogOportunidade(3, data.id)}> {data.totalRegistroDuplicado} </td>
                                            <td onClick={() => exportarLogOportunidade(4, data.id)}> {data.totalRegistroErro} </td>
                                            <td> {data.status} </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <TablePagination data={response} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PerfilSellerListOportunidadeLog;